/**
 * Round 136b - "Getting things ready..." while the server wakes up.
 *
 * The backend scales to zero (owner ruling R135-6: no always-warm instance), so the FIRST request after a quiet spell can take several
 * seconds. Every API call goes through trackFirstCall (apiFetch and publicFetch). Until the page has received its first answer from the
 * server, a call that is still waiting after 2 s raises `emi:warming` (shown by components/errors/WarmingNotice.tsx); the first answer of
 * any kind (success or error) raises `emi:warming-done` and the notice never shows again on this page load. Nothing is retried or delayed.
 */
export const WARMING_EVENT = 'emi:warming';
export const WARMING_DONE_EVENT = 'emi:warming-done';
export const WARMING_AFTER_MS = 2000;

let firstAnswerSeen = false;

function emit(name: string): void {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(name));
}

export function trackFirstCall<T>(call: Promise<T>): Promise<T> {
  if (firstAnswerSeen) return call;
  const timer = setTimeout(() => { if (!firstAnswerSeen) emit(WARMING_EVENT); }, WARMING_AFTER_MS);
  const settle = () => {
    clearTimeout(timer);
    if (!firstAnswerSeen) { firstAnswerSeen = true; emit(WARMING_DONE_EVENT); }
  };
  call.then(settle, settle);
  return call;
}

export function __resetWarmingForTests(): void { firstAnswerSeen = false; }
